import { Ripple, Intersect, Resize } from 'vuetify/lib/directives'

export default {
  Ripple,
  Intersect,
  Resize,
}
